import { render, staticRenderFns } from "./buyer.vue?vue&type=template&id=c345b018&"
import script from "./buyer.vue?vue&type=script&lang=js&"
export * from "./buyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports